import { render, staticRenderFns } from "./water.vue?vue&type=template&id=3cd567fd&scoped=true"
import script from "./water.vue?vue&type=script&lang=js"
export * from "./water.vue?vue&type=script&lang=js"
import style0 from "./water.vue?vue&type=style&index=0&id=3cd567fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd567fd",
  null
  
)

export default component.exports